import type { AtomModel, ResponsiveProp, FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';
import BaseSettingHandler from './BaseSettingHandler';
import hasImageUploadCare from '@/app/utils/hasImageUploadCare';
import HELPER from '@/app/utils/HELPER';
import { getFileExtensionFromSource } from '@/app/utils/helpers';
import { hasImageShopify } from '@/app/utils/replaceImageToSize';
import replaceImageToSize from '@/app/utils/replaceImageToSize';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';

/**
 *
 */
export class ShHtmlAttr extends BaseSettingHandler {
  /**
   * read
   * @param options options
   */
  read(options: { $atom: JQuery; atomModel: AtomModel; screenType: string; $activePanel: JQuery }) {
    // init Selector
    let $target;
    if (this.setting.targetSelector == 'self') {
      $target = options.$atom;
    } else {
      $target = options.$atom.find(this.setting.targetSelector as string);
    }
    let settingName = this.setting.name;
    // init Value render
    let value: any = '';

    // get target attr
    let attrValue = $target.attr(this.setting.property);
    if (this.setting.screen) {
      const responsiveConf = this.getResponsiveSetting(options.screenType);
      if (responsiveConf) {
        attrValue = $target.attr(responsiveConf.property as string);
        settingName = responsiveConf.name;
      }
    }

    if (attrValue) {
      value = attrValue;
    }
    if (this.setting.name == 'v6widget' && options.atomModel.slug == 'ali-reviews') {
      const fields = options.atomModel.settings;
      if (fields && fields.length) {
        const widgetIndex = fields.findIndex((x) => x.name == 'v6widget');
        if (widgetIndex > -1) {
          value = fields[widgetIndex]['default_value'];
        }
      }
    }
    if (!value) {
      value = this.setting.default_value || '';
    }
    if (this.setting.name == 'required' || this.setting.name == 'selected') {
      if (value == this.setting.property) {
        value = '1';
      }
      if (value == '' || value == undefined) {
        value = '0';
      }
    }
    if (this.setting.name == 'description') {
      const $description = $target.next('span');
      value = $description.html();
    }

    // Handle special case
    if (this.setting.property == 'data-scroll-speed') {
      const attrScrollSpeed = HELPER.getDataNameScreen('data-scroll-speed', options.screenType);
      value = $target.attr(attrScrollSpeed);
    }
    if (this.setting.property == 'data-resolution') {
      const imgResolution = options.$atom.attr(`${this.setting.property}`) || '3000x3000';
      $target.attr(this.setting.property, imgResolution);
      value = imgResolution;
    }
    // update common object
    setTimeout(() => {
      options.$activePanel.find(`[name="${settingName}"]`).attr('value', value).val(value).trigger('value-change');
    }, 0);
  }

  /**
   * write
   * @param value value
   * @param options options
   * @returns returns
   */
  write(
    value: any,
    options: {
      screenType: string;
      $atom: JQuery;
      atomModel: AtomModel;
      $activePanel: JQuery;
    },
  ): {
    refreshType: string;
    style?: string | undefined;
  } {
    let refreshType = 'css';
    if (this.setting.refreshType) {
      refreshType = this.setting.refreshType;
    }
    // init Selector
    let $target: JQuery;
    if (this.setting.targetSelector == 'self') {
      $target = options.$atom;
    } else {
      $target = options.$atom.find(this.setting.targetSelector as string);
    }

    let formControlSettings: FormControlSetting[] = [];
    if (options.atomModel.formControlSettings) {
      formControlSettings = options.atomModel.formControlSettings;
    }

    let attrProp = this.setting.property;

    if (this.setting.screen) {
      const responsiveConf = this.getResponsiveSetting(options.screenType);
      if (responsiveConf) {
        attrProp = responsiveConf.property;
      }
    }

    if (this.setting.name == 'widget' && options.atomModel.name == 'LAI AliExpress Reviews') {
      if (!(window as any).gemDragging) {
        (window as any).gemDragging = {};
        (window as any).gemDragging.newLAI = [];
      }
      if (
        (window as any).gemDragging &&
        (window as any).gemDragging.newLAI &&
        (window as any).gemDragging.newLAI.length >= 0
      ) {
        const newLocal = (window as any).gemDragging.newLAI || [];
        if (newLocal && newLocal.length > 0) {
          const index = newLocal.findIndex((x: any) => x.id == options.atomModel.id);
          if (index > -1) {
            newLocal[index].status = 'update';
          }
          try {
            (window as any).gemDragging.newLAI = JSON.parse(JSON.stringify(newLocal));
            // eslint-disable-next-line no-console
          } catch (err) {
            console.log(err);
          }
        }
      }
    }
    if (this.setting.name == 'required' || this.setting.name == 'selected') {
      if (value == '1') {
        value = this.setting.name;
        $target.attr(this.setting.property, value);
      }
      if (value == '0' || value == '') {
        value = '';
        $target.removeAttr(this.setting.property);
      }
    } else if (this.setting.name == 'description') {
      const $description = $target.next('span');
      value = $description.html();
      const desStr = options.$activePanel.find('#description').attr('value') || '';
      $description.html(desStr);
    } else if (this.setting.property == 'data-scroll-speed') {
      const attrScrollSpeed = HELPER.getDataNameScreen('data-scroll-speed', options.screenType);
      $target.attr(attrScrollSpeed, value);
    } else {
      $target.attr(attrProp, value);
    }
    // Handle special case
    switch (this.setting.relatedField) {
      case 'scrollSpeed': {
        formControlSettings.forEach((fcs) => {
          if (fcs.name == this.setting.relatedField) {
            const attrScrollSpeed = HELPER.getDataNameScreen('data-scroll-speed', options.screenType);
            let scrollSpeed: any = $target.attr(attrScrollSpeed);
            if (!scrollSpeed) {
              const defaultSettings: any = DataManager.getAtomDataById(options.atomModel.id).settings || [];
              const obj = defaultSettings.find((obj: any) => obj.name == this.setting.relatedField);
              scrollSpeed = obj['default_value'];
            }
            if (scrollSpeed) {
              options.$activePanel
                .find(`[name="${fcs.name}"]`)
                .attr('value', scrollSpeed)
                .val(scrollSpeed)
                .trigger('value-change');
              $target.attr(attrScrollSpeed, scrollSpeed);
            }
          }
        });
        break;
      }
      case 'image-size':
      case 'image': {
        formControlSettings.forEach((fcs) => {
          if (fcs.name == this.setting.relatedField) {
            const imgResolution: any = options.$activePanel.find('#image-size').attr('value');
            let imgSrc: any = options.$activePanel.find('input[name="image"]').attr('value');
            const imgWidth: any = options.$activePanel.find('#width').attr('value');
            const imgHeight: any = options.$activePanel.find('#height').attr('value');
            if (imgWidth.indexOf('px') != -1 && imgHeight.indexOf('px') != -1) {
              imgSrc = HELPER.changeImageResolution(imgSrc, Math.max(parseInt(imgWidth), parseInt(imgHeight)));
            }
            const isGifUcare = hasImageUploadCare(imgSrc) && !imgSrc.includes('preview/');
            const imgExtension = getFileExtensionFromSource(imgSrc);
            const isSvgShopifyCDN = hasImageShopify(imgSrc) && imgExtension == 'svg';
            if (!(isGifUcare || isSvgShopifyCDN)) {
              imgSrc = replaceImageToSize(imgSrc, imgResolution);
              options.$atom.attr('data-resolution', imgResolution);
              options.$activePanel.find('input[name="image"]').attr('value', imgSrc).trigger('value-change');
            }
            // save stuffs
            const $elemntImg = options.$atom.find('.elm img');
            $elemntImg.attr('src', imgSrc);
          }
        });
        break;
      }
    }
    return {
      refreshType: refreshType,
    };
  }

  /**
   * getResponsiveSetting
   * @param screenType options.screenType
   * @returns ResponsiveProp
   */
  getResponsiveSetting(screenType: string): ResponsiveProp | undefined {
    switch (screenType) {
      case 'xs': {
        return this.setting.screen?.xs;
      }
      case 'sm': {
        return this.setting.screen?.sm;
      }
      case 'md': {
        return this.setting.screen?.md;
      }
      case 'lg': {
        return this.setting.screen?.xs;
      }
      default:
        return {
          name: this.setting.name,
          property: this.setting.property,
        };
    }
  }
}
